// extracted by mini-css-extract-plugin
module.exports = {"header_main":"styles_header_main__1PiHg","header__inner":"styles_header__inner__16mRd","header_elem":"styles_header_elem__121TL"};